import { dialogProps as s } from "./ghl-ui.es1017.js";
import { cardBaseProps as o } from "./ghl-ui.es171.js";
import { keysOf as r } from "./ghl-ui.es959.js";
const e = Object.assign(Object.assign({}, o), s), m = r(e);
export {
  e as presetProps,
  m as presetPropsKeys
};
